export default __webpack_public_path__ + "c6d603d9774c3bda798c56c35f50e4fb.svg";